/* eslint-disable import/no-unresolved */
import React, { useEffect, useMemo, useState } from 'react'
import { fetchAndActivate } from 'firebase/remote-config'
import { getRemoteConfigInstance } from '@dasa/nsw-module-firebase'
import { getConfigContext } from './configContext'
import { defaultConfig } from './defaultConfig'
import { getAllConfig } from './getAllConfig'

export const isProd = () => !!process.env.ENVIRONMENT && ['PRD', 'BETA', 'STG'].includes(process.env.ENVIRONMENT)

export const RemoteConfigProvider: React.FC = ({ children }) => {
    const remoteConfig = useMemo(() => {
        const remoteConfigInstance = getRemoteConfigInstance('RemoteConfig')

        if (!isProd()) {
            remoteConfigInstance.settings = {
                minimumFetchIntervalMillis: 300000,
                fetchTimeoutMillis: 60000,
            }
        }

        return remoteConfigInstance
    }, [])

    const [config, setConfig] = useState(defaultConfig)
    const [loadingRemoteConfig, setLoadingRemoteConfig] = useState(true)
    const ConfigContext = useMemo(() => getConfigContext(), [])
    useEffect(() => {
        const fetchRemoteConfig = async () => {
            remoteConfig.defaultConfig = {
                ...defaultConfig.booleans,
                ...defaultConfig.strings,
                ...defaultConfig.numbers,
                ...defaultConfig.jsons,
            }

            try {
                await fetchAndActivate(remoteConfig)
                // eslint-disable-next-line no-empty
            } catch {}

            const allConfig = getAllConfig(remoteConfig)

            setConfig(allConfig)
            setLoadingRemoteConfig(false)
        }

        fetchRemoteConfig()
    }, [remoteConfig])

    return <ConfigContext.Provider value={{ config, loading: loadingRemoteConfig }}>{children}</ConfigContext.Provider>
}
